module.exports = __webpack_public_path__ + "media/npc_dota_hero_earth_spirit.3b31eec7.webm";